// removed by extract-text-webpack-plugin
module.exports = {"QuestionsContainer":"QuestionsContainer__2km4z","CustomScroll":"CustomScroll__1fp9x"};


//////////////////
// WEBPACK FOOTER
// ./routes/HelpDesk/CategoryQuestions/style.scss
// module id = EbsL
// module chunks = 0